import script from "./VTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTable.vue?vue&type=script&setup=true&lang=ts"

import "./VTable.vue?vue&type=style&index=0&id=7bbd1542&lang=scss"

const __exports__ = script;

export default __exports__